import PropTypes from 'prop-types';
import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';
import ConnectedAdminLaborClasses from '../../Admin/LaborClasses/AdminLaborClasses';
import ConnectedLoggedInChecker from '../../Login/LoggedInChecker/LoggedInChecker';
import ConnectedWorkOrder from '../../WorkOrder/WorkOrder';
import ConnectedAdminClients from '../Clients/AdminClients';
import ConnectedAdminCostCodes from '../CostCodes/AdminCostCodes';
import ConnectedAdminEmployees from '../Employees/AdminEmployees';
import ConnectedAdminEquipments from '../Equipment/AdminEquipments';
import { AdminHeader } from '../Header/AdminHeader';
import ConnectedAdminHome from '../Home/AdminHome';
import ConnectedAdminProjects from '../Projects/AdminProjects';
import ConnectedAdminSubContractors from '../SubContractor/AdminSubContractors';
import './AdminApp.css';
import ConnectedAdminPaymentTypes from '../PaymentTypes/AdminPaymentTypes';
import ConnectedEmployeeStats from '../../EmployeeStats/EmployeeStats';
import ConnectedAdminCostCodeCategories from '../CostCodeCategories/AdminCostCodeCategories';
import ConnectedAdminEquipmentCategories from '../EquipmentCategories/AdminEquipmentCategories';
import { Footer } from '../../Footer/Footer';

export const AdminApp = ({ location }) => (
  <span>
    <ConnectedLoggedInChecker />
    <AdminHeader location={location.pathname} />
    <Grid className="authenticatedAppGrid" fluid >
      <Row>
        <Col xsOffset={1} xs={10} >
          <Switch>
            <Route exact path="/admin" component={ConnectedAdminHome} />
            <Route exact path="/admin/dwrs/:type" component={ConnectedAdminHome} />
            <Route exact path="/admin/clients" component={ConnectedAdminClients} />
            <Route exact path="/admin/employees" component={ConnectedAdminEmployees} />
            <Route exact path="/admin/equipment" component={ConnectedAdminEquipments} />
            <Route exact path="/admin/equipment_categories" component={ConnectedAdminEquipmentCategories} />
            <Route exact path="/admin/paymentTypes" component={ConnectedAdminPaymentTypes} />
            <Route exact path="/admin/projects" component={ConnectedAdminProjects} />
            <Route exact path="/admin/laborClasses" component={ConnectedAdminLaborClasses} />
            <Route exact path="/admin/subcontractors" component={ConnectedAdminSubContractors} />
            <Route exact path="/admin/costcodes" component={ConnectedAdminCostCodes} />
            <Route exact path="/admin/costcodecategories" component={ConnectedAdminCostCodeCategories} />
            <Route exact path="/admin/workorders/:id" component={ConnectedWorkOrder} />
            <Route exact path="/admin/workorders/:id/:action" component={ConnectedWorkOrder} />
            <Route exact path="/admin/stats" component={ConnectedEmployeeStats} />
          </Switch>
        </Col>
      </Row>
      <Row>
        <Footer />
      </Row>
    </Grid>
  </span>);

AdminApp.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
};

AdminApp.defaultProps = {
  location: { pathname: '/' },
};



// WEBPACK FOOTER //
// ./src/components/Admin/AdminApp/AdminApp.jsx